<template>

  <div class="container-fluid p-0">
    <div class="" v-if="checkProductOnShoppingCart(product) && product.is_digital">
      <m-a :href="{name:shoppingCartLink()}">
        <button class="btn btn-primary rounded-pill" v-t="`product.single.shopping_cart`"></button>
      </m-a>
      <button type="button" class="rounded p-0 btn bg-transparent mb-1"
              @click="deleteItemWrapper(order,product, sub_product)">
        <m-icon variant="danger" icon="trash"/>
      </button>
    </div>

    <div v-else class="justify-content-center p-0 w-100 text-center">

      <div dir="rtl">
        <template v-if="product.variation !== 2">
          <button type="button" class="q-link add-to-cart border-0 m-1 p-1"
                  @click="changeItemQuantityWrapper(order,orderProduct(product, sub_product).quantity,product,sub_product, 'up')">
            +
          </button>

          <input type="number" min="1"
                 @keypress="changeInputQuantity"
                 v-model="orderProduct(product, sub_product).quantity"
                 :style="{width:`${setInputSize(orderProduct(product, sub_product).quantity)}px`}"
                 class="text-center quantity-input-manager d-inline border-1 form-control"/>

          <button type="button" class="q-link add-to-cart border-0 m-1 p-1" :class="minusClass()"
                  @click="changeItemQuantityWrapper(order,orderProduct(product, sub_product).quantity,product,sub_product, 'down')"
                  :disabled="orderProduct(product, sub_product).quantity==1">-
          </button>
        </template>


        <button type="button" class="rounded p-0 btn bg-transparent mb-1 my-auto"
                :class="trashClass()"
                @click="deleteItemWrapper(order,product, sub_product)">
          <m-icon variant="danger" icon="trash"/>
        </button>

      </div>


    </div>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import {findHashProductOnLocalStorage} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';
import mIcon from '../Icons/Icon'
import mA from '../Tags/A.vue'
import {
  updateUnAuthItemQuantity,
  findProductOnAuthenticatedOrder,
  removeProductFromLocalStorage,
  orderProduct,
  shoppingCartLink,
  changeItemQuantity,
  checkProductOnShoppingCart,
  deleteItem,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import debounce from "lodash/debounce";

export default {
  name: "ShoppingCartQuantityManager",
  components: {mIcon, mA},
  data() {
    return {
      quantityInputWidth: 40,
    }
  },
  props: {
    product: {},
    sub_product: {
      default: null
    },
    showTrashOnlyInFirstQuantity: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated',
      order: "ShoppingCart/getSidebarBasketData",
    }),
  },
  methods: {
    orderProduct,
    updateUnAuthItemQuantity,
    findProductOnAuthenticatedOrder,
    removeProductFromLocalStorage,
    findHashProductOnLocalStorage,
    changeItemQuantity,
    deleteItem,
    shoppingCartLink,
    checkProductOnShoppingCart,
    async changeItemQuantityWrapper() {
      await this.changeItemQuantity(...arguments)
      await this.refreshComponent()
      await this.$emit('updateQuantity', true)
      let storageEvent = new Event(`unauthenticatedShoppingCardData`);
      window.dispatchEvent(storageEvent);
    },
    async deleteItemWrapper() {
      await deleteItem(...arguments)
      await this.$emit('updateQuantity', true)

      let storageEvent = new Event(`unauthenticatedShoppingCardData`);
      window.dispatchEvent(storageEvent);

    },
    changeInputQuantity: debounce(function (data) {
      let target = data.target;
      const quantity = target.value
      this.changeItemQuantityWrapper(this.order, quantity, this.product, this.sub_product, 'free')
    }, 700),
    setInputSize(quantity) {
      quantity = this.quantityInputWidth + parseInt(quantity) / 2;
      if (quantity > 150) {
        quantity = 150
      }
      return quantity
    },
    refreshComponent() {
      this.$forceUpdate();
    },
    getQuantities() {
      return this.orderProduct(this.product, this.sub_product).quantity
    },
    trashClass() {
      if (this.showTrashOnlyInFirstQuantity) {
        return this.getQuantities() === 1 && this.showTrashOnlyInFirstQuantity ? 'mr-2' : 'd-none'
      }
      return ''
    },
    minusClass() {
      if (this.showTrashOnlyInFirstQuantity) {
        return this.getQuantities() > 1 ? '' : 'd-none'
      }
      return ''
    }
  },
  mounted() {
    window.addEventListener(`unauthenticatedShoppingCardData`, () => {
      this.refreshComponent()
    });
  },
}
</script>

<style scoped>
.q-link {
  height: 28px;
  width: 27px;
  vertical-align: middle;
  background-color: var(--secondary) !important;
  color: var(--light) !important;
}

.add-to-cart {
  border-radius: 50%;
  background-color: var(--primary) !important;
  color: white !important;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.quantity-input-manager {
  height: 35px;
  border-radius: 4px;
  outline: none;
}

</style>